import styled from 'styled-components'

export const Objectives = styled.div`
  margin-top: 3em;
`
